import React, { useState, useRef, } from 'react';
import Magnifier from 'react-magnifier';
import logo from '../../assets/report/logo.png';
import qr from '../../assets/report/qr.png';
import device from '../../assets/report/device.png';
import network from '../../assets/report/network.png';
import health from '../../assets/report/health.png';
import img1 from '../../assets/report/img1.png';
import img2 from '../../assets/report/img2.png';
import a from '../../assets/report/a.png';
import globe from '../../assets/report/globe.png';
import mob from '../../assets/report/mob.png';
import ins from '../../assets/report/ins.png';
import lin from '../../assets/report/lin.png';
import fac from '../../assets/report/fac.png';
import pin from '../../assets/report/pin.png';
import goog from '../../assets/report/goog.png';
import avatar from '../../assets/profile.png';
import ImageGallery from 'react-image-gallery';
import "react-image-gallery/styles/css/image-gallery.css";
import QRCode from "react-qr-code";


import './Report.css';

//Device Images
import Back from '../../assets/report/device/Back.jpg';
// import Behind from '../../assets/report/device/Behind.jpg';
// import Front_LightAngle1 from '../../assets/report/device/Font_LightAngle1.jpg';
// import Front_LightAngle2 from '../../assets/report/device/Font_LightAngle2.jpg';
// import Front_LightAngle3 from '../../assets/report/device/Font_LightAngle3.jpg';
// import Front_LightAngle4 from '../../assets/report/device/Font_LightAngle4.jpg';
// import Front_LightAngle5 from '../../assets/report/device/Font_LightAngle5.jpg';
// import Front_LightAngle6 from '../../assets/report/device/Font_LightAngle6.jpg';
// import Front_LightAngle7 from '../../assets/report/device/Font_LightAngle7.jpg';
// import Front_LightAngle8 from '../../assets/report/device/Font_LightAngle8.jpg';
import Front from '../../assets/report/device/Front.jpg';

//GRADE B
function Report1() { 
  const [isFullscreen, setIsFullscreen] = useState(false);

  const handleScreenChange = (isFullScreen) => {
    setIsFullscreen(isFullScreen);
  };

  const renderImage = (image) => (       
      <Magnifier
        src={image.original}
        mgShape="circle"
        mgShowOverflow={false}
        mgWidth={200}
        mgHeight={200}
        zoomFactor={1.5}
        alt="Device image"
        style={{ width: "100%" }}
      />    
  );

  //Carousel Images
  const CarouselImages = [
    { original: Front, thumbnail: Front },
    { original: Back, thumbnail: Back },
    // { original: Behind, thumbnail: Behind },
    // { original: Front_LightAngle1, thumbnail: Front_LightAngle1 },
    // { original: Front_LightAngle2, thumbnail: Front_LightAngle2 },
    // { original: Front_LightAngle3, thumbnail: Front_LightAngle3 },
    // { original: Front_LightAngle4, thumbnail: Front_LightAngle4 },
    // { original: Front_LightAngle5, thumbnail: Front_LightAngle5 },
    // { original: Front_LightAngle6, thumbnail: Front_LightAngle6 },
    // { original: Front_LightAngle7, thumbnail: Front_LightAngle7 },
    // { original: Front_LightAngle8, thumbnail: Front_LightAngle8 },
    
  ];


  const column1 = [
    { name: "Microphone", status: "FAIL" },
    { name: "Bluetooth", status: "PASS" },
    { name: "Camera", status: "PASS" },
    { name: "Camera Front Present", status: "PASS" },
    { name: "Camera Front Result", status: "PASS" },
    { name: "Camera Rear Present", status: "PASS" },
    { name: "Camera Rear Result", status: "PASS" },
    { name: "Earpiece", status: "FAIL" },
    { name: "Face ID", status: "PASS" },
    { name: "Force Touch", status: "NOT SUPPORTED" },
  ];

  const column2 = [
    { name: "Flashlight", status: "PASS" },
    { name: "GPS", status: "PASS" },
    { name: "Home Button", status: "NOT SUPPORTED" },
    { name: "Light Sensor", status: "FAIL" },
    { name: "Line Draw Test", status: "PASS" },
    { name: "Multi Touch Screen", status: "PASS" },
    { name: "Mute Key", status: "PASS" },
    { name: "Power Button", status: "PASS" },
    { name: "Proximity Sensor", status: "PASS" },
    { name: "Rooted", status: "PASS" },
  ];

  const column3 = [
    { name: "Speaker", status: "PASS" },
    { name: "Touch ID", status: "NOT SUPPORTED" },
    { name: "Vibration", status: "FAIL" },
    { name: "Volume Down Key", status: "PASS" },
    { name: "Volume Up Key", status: "PASS" },
    { name: "Jailbreak", status: "PASS" },
  ];



    const leftColumn = [
      { name: "Cellular", value: "f0:a3:5a:78:18:07" },
      { name: "Battery", value: "F8Y9443137SM6YN7W" },
      { name: "LCD", value: "DKH9393F7E2KV29A0" },
    ];
  
    const rightColumn = [
      { name: "ANumber", value: "A2111" },
      { name: "Region", value: "LL/A" },
      { name: "Main Board", value: "F3X947113E4L73WC" },
    ];
  
  
    return (
        <div className="App">
      <header className="App-header">
             <div className="container">
               <div className="row d-flex align-items-center justify-content-between">
            
                 <div className="col-md-4 text-start">
                   <a
                     className="App-link"
                    target="_blank"
                     rel="noopener noreferrer"
                   >
                     <img src={logo} className="App-logo" alt="logo" />
                   </a>
                 </div>
                        
                 <div className="col-md-4 text-center">
                   <button className="phone-value-button">Cosmetic Condition: Better</button>
                 </div>
                 
                 <div className="col-md-4 text-end">
                   <p>
                     DEVICE INSPECTION <span className="status">Completed</span>
                   </p>
                 </div>
               </div>
             </div>
           </header>

          <section className='sec-1'>
            <div className='container'>
              <div className='row align-items-center'>
                <div className='col-md-6'>
                  <div className="f-left">
                    <div className="row align-items-center">
                      <div className="col-md-9">
                        <ul>
                          <li>Report ID</li>
                          <li>1222615741</li>
                          <li>Start Time</li>
                          <li>04 March 2025 15:05:25</li>
                          <li>Finish Time</li>
                          <li>04 March 2025 15:06:17</li>
                          <li>Serial Number</li>
                          <li>F2LG5HN30D46</li>
                          <li>Device ID</li>
                          <li>00008101-000105843663001E</li>
                        </ul>
                      </div>
                  
                      <div className="col-md-3">
                      <QRCode
                        size={256}
                        style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                        value={`https://report.gearvu.io/report-1`}
                       
                      />
                      </div>
                    </div>
                  </div>
                </div>

                <div className='col-md-6'>
                  <div className="row">
                    <div className="col-md-6">
                    <ul>
                      <li><strong>ANALYST</strong></li>
                      <li>ID: <strong>1224260073</strong></li>
                      <li>Application Version: <strong>2.0.0.46W</strong></li>
                      <li>Device Version: <strong>00008101</strong></li>
                      <li>License ID: <strong>37272</strong></li>
                      <li>Site ID: <strong>1834</strong></li>
                    </ul>
                  </div>
                  <div className="col-md-6">
                    <ul>
                      <li><strong>REPORT</strong></li>
                      <li>Result: <strong>Completed</strong></li>
                      <li>Type: <strong>Analyst</strong></li>
                      <li>Action: <strong>Complete</strong></li>
                      {/* <li>User Name: <strong>Alveria</strong></li>
                      <li>Operator: <strong>Alveria</strong></li> */}
                    </ul>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </section>

          <section className="sec-2">
                      <div className="container">
                        <div className="row pt-3">
                          <div className="col-md-4 px-3">
                            <div className="card-inner">
                              <img src={device} className="img-fuild" alt="device" />
                              <h2>
                                DEVICE <br />
                                INFORMATION
                              </h2>
          
                              <div className="row">
                                <div className="col-md-12">
                                  <ul className="text-start">
                                  <li><strong>Model</strong></li>
                                  <li>iPhone 12 Pro</li>
                                    <li><strong>IMEI</strong></li>
                                   <li>357771759465425</li> 
                                    <li><strong>Memory</strong></li>
                                    <li>256GB</li>
                                    <li><strong>RAM</strong></li>
                                    <li>6GB</li>
                                    <li><strong>CPU</strong></li>
                                    <li>A14 Bionic</li>
                                    <li><strong>Color</strong></li>
                                    <li>Pacific Blue</li>   
                                    <li><strong>Serial #</strong></li>
                                    <li>F2LG5HN30D46</li>
                                    <li><strong>Model #</strong></li>
                                    <li>MG9J3LL/A</li>
                                    {/* <li><strong>Manufacturer</strong></li> */}
          
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-4 px-3">
                            <div className="card-inner">
                              <img src={network} className="img-fuild" alt="network" />
                              <h2>NETWORK COMPATABILITY</h2>
                              <div className="row">
                                <div className="col-md-12">
                                  <ul className="text-start">
                                  <li><strong>Baseband Version</strong></li>
                                  <li>5.20.03</li>
                                  <li><strong>Build Version</strong></li>
                                  <li>22D72</li>
                                  <li><strong>Country Origin</strong></li>
                                  <li>US, Canada</li>
                                  <li><strong>IMEI 2</strong></li>
                                  <li>357771759067312</li>
                                  <li><strong>ECID</strong></li>                      
                                  <li>105843663001E</li>
                                  <li><strong>Region</strong></li>
                                  <li>LL/A</li> 
                                  <li><strong>Rooted</strong></li>
                                  <li>PASS</li>
                                  <li><strong>Manufacture Date</strong></li>
                                  <li>08/01/2021</li>
                                  </ul>
                                </div> 
                              </div>                    
                            </div>
                          </div>
                          
                          <div className="col-md-4 px-3">
                            <div className="card-inner">
                              <img src={health} className="img-fuild" alt="health" />
                              <h2>DEVICE BATTERY HEALTH</h2>
                              <div className="row">
                                <div className="col-md-12">
                                  <ul className="text-start">
                                    <li><strong>Design Capacity</strong></li>
                                    <li>3687</li>
                                    <li><strong>Cycle Count</strong></li>    
                                    <li>782</li>     
                                    <li><strong>Grading</strong></li>
                                    <li>Grade B</li>
                                    <li><strong>Health</strong></li>
                                    <li>84%</li>
                                    <li><strong>Manufacture Date</strong></li>
                                    <li>06/18/2021</li>
                                    <li><strong>Percentage</strong></li>
                                    <li>84</li>
                                    <li><strong>Serial</strong></li>
                                    <li>F8Y12550FHQQ4C2</li>
                                    <li><strong>Temperature</strong></li> 
                                    <li>27</li>    
                                  </ul>
                                </div>
                               </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>
    
          {/* Images */}
          <section className="sec-3">
              <div className="container">
                <div className="row pt-3">
                  <div className="img-box">                      
                    <ImageGallery
                       items={CarouselImages?.map(image => ({
                      ...image,
                      renderItem: () => renderImage(image),
                      }))}
                        showThumbnails={!isFullscreen}
                        showFullscreenButton={true}
                        onScreenChange={handleScreenChange}
                      />

                  </div>
                </div>
              </div>
               </section> 
  
    
          <section className="sec-4">
            <div className="container">
              <div className="row py-5">
                <div className="col-md-4 px-3">
                  <div className="card-inner">
                    <h2>SOFTWARE & DIAGNOSTICS</h2>
                    <div className="row">
                      <div className="col-md-12">
                        <ul className="text-start">
                          <li><strong>OS</strong></li>
                          <li>iOS</li>  
                          <li><strong>Product Version</strong></li>
                          <li>18.3.1</li>  
                          <li><strong>Software Build</strong></li>
                          <li>22D72</li>  
                          <li><strong>A Number</strong></li>
                          <li>A2342</li>  
                          <li><strong>Model</strong></li>
                          <li>D54pAP</li>  
                          <li><strong>Platform</strong></li>
                          <li>t8101</li>  
                          <li><strong>Type</strong></li>
                          <li>iPhone13,4</li> 

                          <li><strong>MLB Serial</strong></li>
                          <li>F3X13140DP2P566C</li>   
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-md-4 px-3">
                  <div className="card-inner">
                    <h2>MOBILE DEVICE MANAGEMENT(MDM)</h2>
                    <div className="row">
                      <div className="col-md-12">
                        <ul className="text-start">
                          <li><strong>MDM Status</strong></li>
                          <li>OFF</li>  
                          <li><strong>MLB Serial</strong></li>
                          <li>F3X13140DP2P566C</li> 
                          <li><strong>Date</strong></li>
                          <li>08/01/2021</li>  
                          <li><strong>Product</strong></li>
                          <li>18.3.1</li>  
                          <li><strong>Product Type</strong></li>
                          <li>iPhone13,4</li> 
                          <li><strong>Rooted</strong></li>
                          <li>PASS</li>
                          <li><strong>Software</strong></li>
                          <li>22D72</li>  
                          <li><strong>Base Band</strong></li>
                          <li>5.20.03</li>  
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-md-4 px-3">
                  <div className="card-inner">
                    <h2>ADDITIONAL INFORMATION</h2>
                    <div className="row">
                      <div className="col-md-12">
                        <ul className="text-start">
                          <li><strong>CPU</strong></li>
                          <li>arm64e</li>  
                          <li><strong>CPU Speed</strong></li>
                          <li>2.99 GHz</li>  
                          <li><strong>Decimal MEID</strong></li>
                          <li>08970202770972</li> 
                          <li><strong>Enclosure Color</strong></li>
                          <li>9</li>  
                          <li><strong>FMIP</strong></li>
                          <li>OFF</li> 
                          <li><strong>LCD Resolution</strong></li>
                          <li>720*1080</li> 
                          <li><strong>Screen Size</strong></li>
                          <li>5.5</li>
                          <li><strong>FMIP</strong></li>
                          <li>OFF</li>  
                        </ul>
                      </div>
                     </div>
                  </div>
                </div>


              

                {/* <div className="col-md-4 px-3">
                  <div className="card-inner">
                    <h2>BANDS<br /><br /></h2>
                    <ul className="text-center">
                      <li>LTE</li>
                      <li>N/A</li>
                      <li>TD-LTE</li>
                      <li>N/A</li>
                      <li>FDD-LTE</li>
                      <li>N/A</li>
                      <li>TD-SCDMA</li>
                      <li>N/A</li>
                      <li>CDMA EV-DO</li>
                      <li>N/A</li>
                      <li>UMTS/HSP</li>
                      <li>N/A</li>
                      <li>GSM/EDGE</li>
                      <li>N/A MHz</li>
                    </ul>
                  </div>
                </div> */}              
              </div>

              <div className="row py-5">
      <div className="col-md-12 px-3">
        <div className="card-inner px-5">
          <h2>HARDWARE INSPECTION</h2>
          <div className="row">
            {[column1, column2, column3].map((column, colIndex) => (
              <div key={colIndex} className="col-md-4">
                <ul className="text-start">
                  {column.map((item, index) => (
                    <li key={index}>
                      <i
                        className={`fa-${
                          item.status === "PASS"
                            ? "regular fa-circle-check success-icon"
                            : "solid fa-ban error-icon"
                        }`}
                      ></i>{" "}
                      {item.name} :{" "}
                      <span className={item.status === "PASS" ? "text-success" : "text-danger"}>
                        {item.status}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>


          

          {/* Test Cases Summary */}
          <div className="test-summary mt-3">
            <span className="text-success">
              ✅ Passed Test Cases: <strong>19</strong>
            </span>
            &nbsp;&nbsp;
            <span className="text-danger">
              ❌ Failed Test Cases: <strong>4</strong>
            </span>
          </div>
        </div>
      </div>
    </div>


    <div className="row py-5">
      <div className="col-md-12 px-3">
        <div className="card-inner px-5">
          <h2>PARTS REPLACED</h2>
          <div className="row">
            <div className="col-md-6">
              <ul className="text-start">
                {leftColumn.map((item, index) => (
                  <li key={index}>
                    <i className="fa-regular fa-circle-check success-icon"></i>{" "}
                    <strong>{item.name}</strong> : {item.value} -{" "}
                    <span className="text-success">No Replacement</span>
                  </li>
                ))}
              </ul>
            </div>
            <div className="col-md-6">
              <ul className="text-start">
                {rightColumn.map((item, index) => (
                  <li key={index}>
                    <i className="fa-regular fa-circle-check success-icon"></i>{" "}
                    <strong>{item.name}</strong> : {item.value} -{" "}
                    <span className="text-success">No Replacement</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    </div>
          </section>


          <footer>
            <div className="container">
              <div className="row py-5 align-items-center">
              <div className="col-md-8 text-start">
                  <img src={logo} className="img-fluid flogo" alt="fogo" />
                  {/* <div className="socials">
                    <img src={goog} className="img-fluid" alt="goog" />
                    <img src={fac} className="img-fluid" alt="fac" />
                    <img src={lin} className="img-fluid" alt="lin" />
                    <img src={pin} className="img-fluid" alt="pin" />
                    <img src={ins} className="img-fluid" alt="ins" />
                  </div> */}
                </div>
              <div className="col-md-4">
                  <h3>For Queries: </h3>
                  <ul>
                    <li>
                      <img src={a} className="img-fluid" alt="a" /> 
                      <a href="mailto:info@GearVu.com">info@GearVu.com</a>
                    </li>
                    <li>
                      <img src={mob} className="img-fluid" alt="mob" /> 
                      <a href="tel:18552168091">1.855.216.8091</a>
                    </li>
                    <li>
                      <img src={globe} className="img-fluid" alt="globe" /> 
                      <a href="https://GearVu.com" target="_blank" rel="noopener noreferrer">GearVu.com</a>
                    </li>
                    <li>
                      <img src={lin} className="img-fluid" alt="lin" /> 
                      <a href="https://www.linkedin.com/company/GearVu" target="_blank" rel="noopener noreferrer">GearVu</a>
                    </li>
                  </ul>
                </div>

                
    
               
              </div>
            </div>
          </footer>
          <div className="footer-bottom">
            <p>©2024, GearVu®  All rights reserved.</p>
          </div>
        </div>
      );
}

export default Report1;